import { ReactNode, createContext } from 'react';
import { FeatureValue } from '../../entities';
import { useFeatureFlags } from '../../hooks';

type FeatureVariationsProps = {
  name: string;
  children: ReactNode;
};

export const FeatureVariationsContext = createContext<FeatureValue>(null!);

const FeatureVariations = ({ name, children }: FeatureVariationsProps) => {
  const { featureFlags } = useFeatureFlags();
  const featureValue = featureFlags.getFeatureValue(name);

  return <FeatureVariationsContext.Provider value={featureValue}>{children}</FeatureVariationsContext.Provider>;
};

export default FeatureVariations;
